export const _setIsLogout = (state, action) => {
  state.isLogout = action.payload;
};

export const _setIsLogoutTiming = (state, action) => {
  state.isLogoutTiming = action.payload;
};
